import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { RuleObject } from 'antd/es/form';

export type SonarInputRule = Omit<RuleObject, 'type'>;

export const getRequiredRule = (fieldName: string): SonarInputRule => ({
	message: COPY_SPECIFIC.FIELD_REQUIRED(fieldName),
	required: true
});

export const getMaxRule = (fieldName: string, max: number): SonarInputRule => ({
	max,
	message: COPY_SPECIFIC.FIELD_CANNOT_EXCEED(fieldName, max)
});

export function validateText(currentValue: string, validationRules?: Array<SonarInputRule>): string | undefined {
	for (const rule of validationRules ?? []) {
		if (rule.required && !currentValue) {
			return rule.message as string;
		}

		if (!rule.required && !currentValue) {
			return undefined;
		}

		if (rule.min && currentValue.length < rule.min) {
			return rule.message as string;
		}

		if (rule.max && currentValue.length > rule.max) {
			return rule.message as string;
		}

		if (rule.pattern && !rule.pattern.test(currentValue)) {
			return rule.message as string;
		}
	}

	return undefined;
}
